/** A whitespace-only or extension-only value is not a technical drawing. */
export function hasDrawingName(value) {
    if (typeof value !== 'string') return false;
    const name = value.trim();
    const stem = name.includes('.') ? name.split('.').slice(0, -1).join('.') : name;
    return Boolean(stem.trim()) && !/^[.\s]+$/.test(stem);
}
